/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seller_Settings_Stripe_ConnectInputs */

const en_seller_settings_stripe_connect = /** @type {(inputs: Seller_Settings_Stripe_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Stripe`)
};

const es_seller_settings_stripe_connect = /** @type {(inputs: Seller_Settings_Stripe_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectar Stripe`)
};

const fr_seller_settings_stripe_connect = /** @type {(inputs: Seller_Settings_Stripe_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connecter Stripe`)
};

const de_seller_settings_stripe_connect = /** @type {(inputs: Seller_Settings_Stripe_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe verbinden`)
};

const ja_seller_settings_stripe_connect = /** @type {(inputs: Seller_Settings_Stripe_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripeを接続`)
};

const zh_seller_settings_stripe_connect = /** @type {(inputs: Seller_Settings_Stripe_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`连接 Stripe`)
};

const ar_seller_settings_stripe_connect = /** @type {(inputs: Seller_Settings_Stripe_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ربط Stripe`)
};

const id_seller_settings_stripe_connect = /** @type {(inputs: Seller_Settings_Stripe_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungkan Stripe`)
};

const it_seller_settings_stripe_connect = /** @type {(inputs: Seller_Settings_Stripe_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connetti Stripe`)
};

const ru_seller_settings_stripe_connect = /** @type {(inputs: Seller_Settings_Stripe_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подключить Stripe`)
};

const pt_seller_settings_stripe_connect = /** @type {(inputs: Seller_Settings_Stripe_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conectar Stripe`)
};

const ko_seller_settings_stripe_connect = /** @type {(inputs: Seller_Settings_Stripe_ConnectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stripe 연결`)
};

/**
* | output |
* | --- |
* | "Connect Stripe" |
*
* @param {Seller_Settings_Stripe_ConnectInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const seller_settings_stripe_connect = /** @type {((inputs?: Seller_Settings_Stripe_ConnectInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seller_Settings_Stripe_ConnectInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_seller_settings_stripe_connect(inputs)
	if (locale === "es") return es_seller_settings_stripe_connect(inputs)
	if (locale === "fr") return fr_seller_settings_stripe_connect(inputs)
	if (locale === "de") return de_seller_settings_stripe_connect(inputs)
	if (locale === "ja") return ja_seller_settings_stripe_connect(inputs)
	if (locale === "zh") return zh_seller_settings_stripe_connect(inputs)
	if (locale === "ar") return ar_seller_settings_stripe_connect(inputs)
	if (locale === "id") return id_seller_settings_stripe_connect(inputs)
	if (locale === "it") return it_seller_settings_stripe_connect(inputs)
	if (locale === "ru") return ru_seller_settings_stripe_connect(inputs)
	if (locale === "pt") return pt_seller_settings_stripe_connect(inputs)
	return ko_seller_settings_stripe_connect(inputs)
});